import { Routes, Route } from "react-router-dom"
import { useContext, useEffect, useState } from 'react';
import { ToastContainer } from "react-toastify";
import Layout from './components/Layout';
import React from 'react';
import NotFound from './components/NotFound';
import Main from './components/Main';
import './App.css';
import { MainProvider } from "./store/mainContext";
import Control from "./components/Control";
import cardService from "./services/cardServices";
import MapOffline from './components/MapOffline';
export default () => {

  const [defaultDevice, setDefaultDevice] = useState(null)

  useEffect(() => {
    setDefaultDevice(cardService.getChoiceCard());
  }, [])


  return (
    <>
      <ToastContainer
        bodyClassName={() => "myToastClass"}
        position="bottom-center"
        autoClose={3000}
        hideProgressBar={true}
        rtl={true}
      />
      <MainProvider value={
        {
          defaultDevice: defaultDevice,
          setDefaultDevice: setDefaultDevice,
        }
      }>
        <Routes>
          {/*<Route path='/login' element={<Login />} />*/}
          <Route path='/map' element={<MapOffline />} />
          <Route path="/map/:lat/:lng" element={<MapOffline />} />
          <Route path="/map/:coords" element={<MapOffline />} />


          <Route element={<Layout />} >

            <Route path='/main' element={<Main />} />
            <Route path='/control' element={<Control />} />
            <Route exact path='/' element={<Main />} />

            <Route path="*" element={<NotFound />} />
          </Route>

        </Routes>
      </MainProvider >
    </>
  );
} 
